<div fxLayout="row" fxLayoutAlign="center center">
  <div *ngIf="!params.icon && !params.svgIcon" class="iconCellRendererLabel">{{params.displayName}}</div>
  <div *ngIf="params.icon || params.svgIcon" fxLayout="row" class="icon-renderer" matTooltip="{{params.description}}">
    <mat-icon *ngIf="params.icon" [ngStyle]="params.iconStyle" [ngClass]="params.iconClass">{{params.icon}}</mat-icon>
    <mat-icon *ngIf="params.svgIcon" svgIcon="{{params.svgIcon}}" [ngStyle]="params.iconStyle" class="no-tooltip" [ngClass]="params.iconClass"></mat-icon>
  </div>
</div>
